import { render, staticRenderFns } from "./DashboardPemohon.vue?vue&type=template&id=42df9c4a&"
import script from "./DashboardPemohon.vue?vue&type=script&lang=js&"
export * from "./DashboardPemohon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports